export default "__VITE_ASSET__XnISftS3__"